import script from "./new-password-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-password-input.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__